<template>
  <el-dialog
    :title="$t('deleteStaff.confirmOperation')"
    :visible.sync="dialogVisible"
    width="40%"
    center>
    <div class="text-center warning-message">
      <p>{{ $t('deleteStaff.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteStaff">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteStaff } from '@/api/frame/staffApi'

export default {
  name: 'DeleteStaff',
  data() {
    return {
      dialogVisible: false,
      staffInfo: {}
    }
  },
  methods: {
    open(staffInfo) {
      this.staffInfo = staffInfo
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    async deleteStaff() {
      try {
        const res = await deleteStaff(this.staffInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('deleteStaff.deleteSuccess'))
          this.$emit('success')
          this.close()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style scoped>
.warning-message {
  color: #f56c6c;
  font-size: 16px;
  padding: 20px 0;
}
.text-center {
  text-align: center;
}
</style>